<template>
    <div class="mb-4">
        <label class="form-label">
            {{ label }}
        </label>

        <textarea :id="id" v-model="value" :name="name" />
    </div>
</template>

<script>
import { v4 as uuidV4 } from "uuid";

export default {
    name: "FormKitCKEditor",
    props: {
        label: {
            type: String,
        },
        name: {
            type: String,
        },
        modelValue: {},
        timeout: null,
    },
    mounted() {
        setTimeout(() => {
            CKEDITOR.dtd.$removeEmpty.i = 0;

            let editor = CKEDITOR.replace(this.id, {
                allowedContent: true,
                filebrowserImageBrowseUrl:
                    "/admin/laravel-filemanager?type=Images",
                filebrowserImageUploadUrl:
                    "/admin/laravel-filemanager/upload?type=Images&_token=",
                filebrowserBrowseUrl: "/admin/laravel-filemanager?type=Files",
                filebrowserUploadUrl:
                    "/admin/laravel-filemanager/upload?type=Files&_token=",
            });

            editor.on("change", (e) => {
                this.value = editor.getData();
            });
        }, 1000);
    },
    destroyed() {
        clearTimeout(this.timeout);
    },
    data() {
        return {
            value: this.modelValue ?? "",
            id: `editor-${uuidV4()}`,
        };
    },
    watch: {
        value(value) {
            this.$emit("input", value);
            this.$emit("update:modelValue", value);
        },
    },
};
</script>
